import Request from './request';
import axios from 'axios'
import admin from './module/admin';
import quota from './module/quota';
import common from './common'
import appraise from './module/appraise'

const URLS = {
    ...admin,
    ...quota,
    ...appraise,
    ...common,
}

const Service = {
	fetch(config, query) {
		try {
            return Request.all({
				url: URLS[config.url] + ( query ? query : ''),
				method: config.methods || 'get',
				params: config.params, 
				data: config.data, 
                isUgly: config.isUgly, // 是不是非要在post接口中用query的形式传参
                loading: config.loading,  // 全局loading
                loadingTarget: config.loadingTarget, // loading产生的Dom
				headers: config.headers,
				forceExecute: config.forceExecute, // 是不是请求可以同时触发多个，否则会被cancel
			})
        } catch (error) {
			console.log(error)
		}
	},
    start(config) {
        return Request.all({
            url: URLS[config.url],
            method: config.method || 'post',
            params: config.params,
            data: config.data,
            headers: {
                'Content-Type': 'application/json'
            },  
            loading: config.loading,
            loadingTarget: config.loadingTarget
        })
    },
    del(config){
        return Request.all({
            url: URLS[config.url],
            method: config.method || 'post',
            params: config.params,
            data: config.data,
            loading: config.loading,
            loadingTarget: config.loadingTarget,
            headers: config.headers || {
                'Content-Type': 'application/json'
            }
        })
    }
}

export default Service